<template>
  <div>
    <documentation-template
      title="v-infinite-slidebar"
      :tags="['vue', 'infinite', 'slidebar', 'plugin', 'awesome']"
    >
      <template v-slot:description>
        <h4 class="subtitle is-6">✨ Infinite slide bar component for awesome vue project ✨</h4>
      </template>

      <template v-slot:code-labels>
        <div class="code-labels">
          <a data-v-2eedca07 href="https://npmjs.com/package/v-infinite-slidebar">
            <img
              data-v-2eedca07
              src="https://img.shields.io/npm/v/v-infinite-slidebar.svg"
              alt="NPM
            version"
            />
          </a>
          <a data-v-2eedca07 href="https://npmjs.com/package/v-infinite-slidebar">
            <img
              data-v-2eedca07
              src="https://img.shields.io/npm/dm/v-infinite-slidebar.svg"
              alt="NPM downloads"
            />
          </a>
          <a data-v-2eedca07 href="https://www.npmjs.com/package/v-infinite-slidebar">
            <img
              data-v-2eedca07
              src="https://img.shields.io/npm/l/v-infinite-slidebar.svg"
              alt="License"
            />
          </a>
          <a data-v-2eedca07 href="https://github.com/ichbinkour/v-infinite-slidebar">
            <img
              alt="GitHub stars"
              src="https://img.shields.io/github/stars/ichbinkour/v-infinite-slidebar?style=social"
            />
          </a>
        </div>
      </template>

      <template v-slot:usage>
        <pre v-highlightjs><code class="javascript">import vue from "Vue"<br />import VInfiniteSlidebar from "v-infinite-slidebar"<br /><br />Vue.component('v-infinite-slidebar', VInfiniteSlidebar)</code></pre>
        <strong>Or</strong>
        <pre v-highlightjs style="margin-top: 20px !important;"><code class="javascript">import VInfiniteSlidebar from "v-infinite-slidebar"<br /><br />export default {
  components: {
    VInfiniteSlidebar
  }
}</code></pre>
      </template>

      <template v-slot:example>
        <div class="example-demo-container">
          <h4 class="title is-5"># Simple</h4>

          <v-infinite-slidebar
            :slideBarStyle="{
              background: 'rgb(245 212 199)',
              'padding-top': '5px',
              'padding-bottom': '5px',
            }"
          >
            <span style="color: rgb(162 65 25)">I'm a simple example.</span>
          </v-infinite-slidebar>
          <pre style="padding-bottom: 20px;" v-highlightjs><code class="javascript">{{simpleDemo}}</code></pre>
        </div>
        <div class="example-demo-container">
          <h4 class="title is-5"># Props</h4>

          <v-infinite-slidebar
            :slideBarStyle="{
              background: 'rgb(245 212 199)',
              'padding-top': '5px',
              'padding-bottom': '5px',
            }"
            duration="8s"
            direction="reverse"
          >
            <span style="color: rgb(162 65 25)">I'm an example playing with props.</span>
          </v-infinite-slidebar>
          <pre style="padding-bottom: 20px;" v-highlightjs><code class="javascript">{{propsDemo}}</code></pre>
        </div>
      </template>

      <template v-slot:props-options>
        <b-table bordered :data="data">
          <template slot-scope="props">
            <b-table-column field="name" label="Name">
              <span>
                <code>{{ props.row.name }}</code>
              </span>
            </b-table-column>

            <b-table-column field="type" label="Type">
              <span>
                <code>{{ props.row.type }}</code>
              </span>
            </b-table-column>

            <b-table-column field="default" label="Default">
              <span>
                <code>{{ props.row.default }}</code>
              </span>
            </b-table-column>

            <b-table-column field="description" label="Description">
              <span>{{ props.row.description }}</span>
            </b-table-column>
          </template>
        </b-table>
      </template>
    </documentation-template>
  </div>
</template>

<script>
import VInfiniteSlidebar from "v-infinite-slidebar";
import DocumentationTemplate from "@/views/DocumentationTemplate";

export default {
  name: "VInfiniteSlidebarComponent",
  components: {
    DocumentationTemplate,
    VInfiniteSlidebar
  },
  data() {
    return {
      data: [
        {
          name: "slideBarStyle",
          type: "Obect",
          default: "None",
          description: "Style that will be applied to the component."
        },
        {
          name: "duration",
          type: "String",
          default: "15s",
          description: "Duration of the animation."
        },
        {
          name: "direction",
          type: "String",
          default: "normal",
          description:
            "Direction of the animation, you can also use 'reverse' for example."
        },
        {
          name: "delay",
          type: "String",
          default: "0s",
          description: "Delay before the animation starts."
        },
        {
          name: "paused",
          type: "Boolean",
          default: "false",
          description: "Stop the animation when set to true"
        }
      ],
      simpleDemo: `<v-infinite-slidebar
  :slideBarStyle="{
    background: 'rgb(245 212 199)',
    'padding-top': '5px',
    'padding-bottom': '5px',
  }"
>
  <span style="color: rgb(162 65 25)">I'm a simple example.</span>
</v-infinite-slidebar>`,
      propsDemo: `<v-infinite-slidebar
  :slideBarStyle="{
    background: 'rgb(245 212 199)',
    'padding-top': '5px',
    'padding-bottom': '5px',
  }"
  duration="8s"
  direction="reverse"
>
  <span style="color: rgb(162 65 25)">I'm an example playing with props.</span>
</v-infinite-slidebar>`
    };
  }
};
</script>

<style lang="scss"></style>
